import { combineReducers } from 'redux'

import identity from './app/identity'
import page from './app/page'
import password from './app/password'
import status from './app/status'

export default combineReducers({
  identity,
  page,
  password,
  status
})



// WEBPACK FOOTER //
// ./src/reducers/root/app.js